// removed by extract-text-webpack-plugin
module.exports = {"page":"LoginPage__page___3Pz6P","graphic":"LoginPage__graphic___1DuOe","lettering":"LoginPage__lettering___2cKOJ","error":"LoginPage__error___1d5tr"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/pages/LoginPage.css
// module id = 1210
// module chunks = 0